import { apiPath } from "../../constants";
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const COMPETITION_SECRETARY_POST_REQUEST = 'POST_COMPETITION_SECRETARY_REQUEST';
export const COMPETITION_SECRETARY_POST_FAILURE = 'POST_COMPETITION_SECRETARY_FAILURE';
export const COMPETITION_SECRETARY_POST_SUCCESS = 'POST_COMPETITION_SECRETARY_SUCCESS';

export const postCompetitionSecretary = (data) => {
    return function(dispatch) {
        dispatch(postRequest());
        return axios(apiRequestOptions(apiPath.COMPETITION_SECRETARIES.POST, data))
            .then(transformHttpResponse)
            .then(response => dispatch(postSuccess(response.data)))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const postRequest = () => {return {type: COMPETITION_SECRETARY_POST_REQUEST}};
const postFailure = (error) => {
    return {type: COMPETITION_SECRETARY_POST_FAILURE, error}
};
const postSuccess = (competitionSecretary) => {
    return {type: COMPETITION_SECRETARY_POST_SUCCESS, competitionSecretary}
};